import React, {useEffect, useState} from "react";
import {useLocation} from "react-router";
import {Difficulty} from "../../models/Difficulty";
import {UiSelect} from "../ui-components/select/uiSelect";
import {UiOption} from "../ui-components/select/option/uiOption";
import {Game} from "./game";
import {GameApi} from "../../services/api/GameApi";
import {GameModes} from "../../constants/EnumGameModes";
import {useTranslation} from "react-i18next";

type GameModePageProps = {
    gameMode: GameModes;
    showDifficultySelector?: boolean;
    showBreadcrumb?: boolean;
    containerPadding?: string;
}

export const GameModePage: React.FC<GameModePageProps> = ({
    gameMode,
    showDifficultySelector = true,
    showBreadcrumb = true,
    containerPadding = "xl:px-44"
}) => {
    const {t} = useTranslation();
    const location = useLocation();
    const { gameModeId } = location.state || {};
    const [difficulty, setDifficulty] = useState(2);
    const [tabDifficulty, setTabDifficulty] = useState<Difficulty[]>([]);
    const [defaultDifficulty, setDefaultDifficulty] = useState<number | null>(null);

    useEffect(() => {
        if (showDifficultySelector) {
            GameApi.getGameModeFromDifficulty(gameModeId).then((data: Difficulty[]) => {
                setTabDifficulty(data);
                setDefaultDifficulty(data[0]?.idDifficulty);
            });
        }
    }, [gameModeId, showDifficultySelector]);

    return (
        <div className="px-12 md:px-28 xl:px-28 pt-20 pb-12 md:pt-28 xl:pt-30 flex flex-col gap-8">
            {showDifficultySelector && (
                <div>
                    {showBreadcrumb && (
                        <p>{(location.pathname.substring(1).split('/')).join(' > ')}</p>
                    )}

                    <div className="flex justify-between">
                        <UiSelect
                            onChange={setDifficulty}
                            search={false}
                            defaultValue={defaultDifficulty}
                        >
                            {
                                tabDifficulty.map((element) => {
                                    return (
                                        <UiOption
                                            key={element.idDifficulty}
                                            value={element.idDifficulty}
                                        >
                                            {t(`game.${element.name.toLowerCase()}`)}
                                        </UiOption>
                                    )
                                })
                            }
                        </UiSelect>
                    </div>
                </div>
            )}

            <div className={containerPadding}>
                <Game gameModeId={gameModeId} difficulty={difficulty} gameMode={gameMode} />
            </div>
        </div>
    );
};

